export default function formatSeconds(seconds: number, {showSeconds = false, smallSeconds = false, hideEmptyHours = false} = {})
{
    let string = seconds < 0 ? '-' : '';

    if (isNaN(seconds))
    {
        seconds = 0;
    }

    seconds = Math.abs(seconds);

    let hours = Math.floor(seconds / 3600);
    if (!hideEmptyHours || hours > 0)
    {
        string = hours < 0 ? '' : string;
        string += (hours >= 0 && hours < 10 ? '0' + hours : hours) + ':';
        seconds -= hours * 3600;
    }

    let minutes = Math.floor(seconds / 60);
    string += ('0' + minutes).slice(-2);
    seconds -= minutes * 60;

    if (showSeconds)
    {
        if (smallSeconds)
        {
            string += '<small>';
        }

        string += ':' + ('0' + seconds).slice(-2);

        if (smallSeconds)
        {
            string += '</small>';
        }
    }

    return string;
}